import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import classes from "./News.module.css";
import styles from "./newsClasses.module.css";
import { testUrl } from "../BaseData";
import { Link } from "react-router-dom";
import search from "../../news/assets/icons/search.svg";
import SocialMedias from "../../../shared/components/socialMedias/SocialMedias";
import "moment/locale/uz-latn";
import moment from "moment";
import Pagination from "@mui/material/Pagination";

const NewsCategories = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [news_data, setNews] = useState(null);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [pageApi, setPageApi] = useState(1);
    const itemsPerPage = 9;
    const indexOfLastItem = pageApi * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentNews = (news_data || []).slice(indexOfFirstItem, indexOfLastItem);


    useEffect(() => {
        setLoading(true);
        setError(null);

        const fetchNewsData = axios.get(
            testUrl + "/api/categories/" + id
        );

        const fetchCategoriesData = axios.get(
            testUrl + "/api/categories"
        );


        Promise.all([fetchNewsData, fetchCategoriesData])
            .then(([newsResponse, categoriesResponse]) => {
                const news = newsResponse.data;
                const categoris = categoriesResponse.data;

                if (news && categoris) {
                    setNews(news?.news || []);
                    setCategories(categoris);
                } else {
                    setError("Ma'lumotlar topilmadi");
                }

            })
            .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
            .finally(() => setLoading(false));

    }, [id, i18n.language]);


    const foundItem = categories.find(item => item.id === Number(id));

    if (loading) return <p>Yuklanmoqda...</p>;

    return (

        <div className={classes.mainContainer}>
            <div data-aos="fade-up" className={classes["newsSection"]}>

                <h1 className={classes["page-title"]}>
                    {foundItem ? foundItem?.name_uz : "Yangiliklar"}
                </h1>

                <div className={styles.facultyList}>
                    {currentNews && currentNews.length > 0 ? (
                        currentNews.map((new_data) => (
                            <Link
                                key={`${new_data.source || "news"}-${new_data.id}`}
                                to={
                                    new_data.source === "activity"
                                        ? `/activity/${new_data.id}`
                                        : `/news/${new_data.id}`
                                }
                                className={styles.facultyCard}
                            >
                                <img
                                    src={new_data?.image || "/default-image.jpg"}
                                    alt=" "
                                    className={styles.facultyImage}
                                />
                                <div className={styles.facultyInfo}>
                                    <h3>
                                        {new_data?.[`title_${i18n.language}`] || new_data?.title_uz}
                                    </h3>
                                </div>
                                <div className={styles.newsMetadata}>
                                    <span>
                                        {moment(new_data.posted_time)
                                            .locale(i18n.language)
                                            .format("DD-MMMM, HH:mm")}
                                    </span>
                                    {typeof new_data.view_count === "number" && (
                                        <span>{new_data.view_count} views</span>
                                    )}
                                </div>
                                <div className={styles.viewMore}>
                                    <span>
                                        {t("see_more")}
                                    </span>
                                </div>
                            </Link>
                        ))
                    ) : (
                        <div></div>
                    )}
                </div>
                <div className={classes["center_div"]}>
                    <Pagination
                        onChange={(e, value) => setPageApi(value)}
                        count={Math.ceil((news_data?.length || 0) / itemsPerPage)}
                        variant="outlined"
                        shape="rounded"
                    />
                </div>
            </div>
            <div className={classes.sidebar} style={{ marginLeft: 0, marginRight: "40px" }}>
                <h3>
                    {t("categories")}
                </h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                    <li
                        onClick={() => navigate("/news")}
                        style={{ marginBottom: '10px' }}
                    >
                        <span style={{ marginRight: '8px', color: '#133654', fontWeight: 'bold' }}>1. </span>
                        <span
                            style={{ cursor: 'pointer', color: '#133654' }}
                        >
                            {t("Barcha yangilkilar")}
                        </span>
                    </li>
                    {categories && categories.length > 0 ? (
                        categories.map((category, index) => (
                            <li
                                onClick={() => navigate(`/newscategories/` + category?.id)}
                                key={category.id}
                                style={{ marginBottom: '10px' }}
                            >
                                <span style={{ marginRight: '8px', color: '#133654', fontWeight: 'bold' }}>{index + 2}.</span>
                                <span
                                    style={{ cursor: 'pointer', color: '#133654' }}
                                >
                                    {category[`name_${i18n.language}`]}
                                </span>
                            </li>
                        ))
                    ) : (
                        <li>{t("no_news_found")}</li>
                    )}
                </ul>
            </div>
        </div>

    );
};

export default NewsCategories;
